var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([045belp]|0x|1r|1s|4p|a2|ef|ft|hm|j3|ot|qe|qi)|n([037bdimq]|23|2u|57|95|c5|jx|qa|ya|ze)|2(57|5k|77|7y|86|ci|d6|g3|hd|k|k4)|f([469almx]|w[bin]|2j|4t|bm|d3|n4|n7|ob|pr|rd|sl|to|tw|vi|zs)|q([14bvw]|4j|g9e|j7|k4|mc|tf|v0|x6)|w([7gj]|0q|1v|57|a6|cf|ry|v4|wb5)|z([0aegjtw]|51|a9|bi|dw|f4|me|mu|x5)|o(4[2nq]|15|8|dj|f6|fo|hu|i|uh|uz|wz|xn|za|zc)|k([13efms]|ya(|a)|1f|1z8|4h|54|89|q9|r2|zb)|d([59eikmnz]|30|cm|f6|gb|nc|pi|v7)|l([9bdf]|cd|h5|iy|u0|ym)|7([adjqu]|2a|2d|5z|6u|86|a2|fa|gn|ie|w3)|b(3t|84|am|kn|oc|sc|vx|xt|z)|9([3bglq]|65|87|9u|am|e6|j2|ls|mq|og|p9)|r([9gj]|02|7a|hk|ku|n6|oo|q7|xd|zm|zx)|0([9dgj]|1[5kq]|[aip]g|4y|aj|bc|q9|vb|xz|yx)|t([cdn]|l(3|7|lv)|3a|3w|51|7lm|a6|ah|gm|ii|n9|q8|qs|ue|zh|zn)|i([5iou]|r[4iz]|10|4i|4z|99|a2|ap|b6|c0|gs|k4|kr|lw|nj|ns|w6)|x([9jluz]|2y|4x|a3|bg|bv|gd|hy|mx|rh|y4|yc|zc)|h([16x]|a[58o]|4b|cx|g2|gj|j6|t8|up|wz|ya|yz)|j([5ipq]|29|4f|7g|a4|dp|dv|vb|wb|wf)|3(5|71|92|e9|fl|j3|r4|wj|z)|s([37bcglpry]|0a|61|c1|d9|ex|he|hs|kd|kj|me|tz|vp)|v([9afs]|k[dhn]|b3|ct|fa|n4|og)|1([1789fiotw]|00|f1|iz|jf|mh|mu|ph|rv|vs|x7)|8([ehw]|1s|2x|4j|e8|es|gu|hi|k2|nm|ov|qc|w4|xc)|g(11|64|9|j9|x|yb|yf|zt)|p([29ds]|3x|6o|n8|v3|yvv)|4([1nv]|7[6eh]|17|2a|bi|eg|ft|hh|hs|uu|v5)|a([2fiw]|3u|7h|7y|9o|ck|cv|do|eb|ikj|jn|k3|rf)|5([456mu]|0s|1p|6n|gc|kk|rd|s9)|c(23|4|4t|8|8a|kc|mi|n9)|6([3ouvwy]|19|3t|8y|96|cd|co|fq|gc|q6|v8|vyp|zy)|u((|u|w)8|2l|5z|dt|gm|hn|n|wq)|e([5flrw]|2b|2f|98|ah|av|l9|mz|tb|tk3|vi|vw|wo)|y(2q|7n|ek|j|kw|l8|yi|zx))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
